/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OfferStateEnum } from './OfferStateEnum';
import {
    OfferStateEnumFromJSON,
    OfferStateEnumFromJSONTyped,
    OfferStateEnumToJSON,
    OfferStateEnumToJSONTyped,
} from './OfferStateEnum';

/**
 * 
 * @export
 * @interface InvoiceItem
 */
export interface InvoiceItem {
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    idOffer: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    idCustomer: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItem
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItem
     */
    partner: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItem
     */
    user: string;
    /**
     * 
     * @type {OfferStateEnum}
     * @memberof InvoiceItem
     */
    state: OfferStateEnum;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    interval: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItem
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    cloud?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    maintenance?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    amount: number;
}



/**
 * Check if a given object implements the InvoiceItem interface.
 */
export function instanceOfInvoiceItem(value: object): value is InvoiceItem {
    if (!('idOffer' in value) || value['idOffer'] === undefined) return false;
    if (!('idCustomer' in value) || value['idCustomer'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('partner' in value) || value['partner'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function InvoiceItemFromJSON(json: any): InvoiceItem {
    return InvoiceItemFromJSONTyped(json, false);
}

export function InvoiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'idOffer': json['idOffer'],
        'idCustomer': json['idCustomer'],
        'customer': json['customer'],
        'partner': json['partner'],
        'user': json['user'],
        'state': OfferStateEnumFromJSON(json['state']),
        'interval': json['interval'],
        'date': json['date'],
        'cloud': json['cloud'] == null ? undefined : json['cloud'],
        'maintenance': json['maintenance'] == null ? undefined : json['maintenance'],
        'amount': json['amount'],
    };
}

export function InvoiceItemToJSON(json: any): InvoiceItem {
    return InvoiceItemToJSONTyped(json, false);
}

export function InvoiceItemToJSONTyped(value?: InvoiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idOffer': value['idOffer'],
        'idCustomer': value['idCustomer'],
        'customer': value['customer'],
        'partner': value['partner'],
        'user': value['user'],
        'state': OfferStateEnumToJSON(value['state']),
        'interval': value['interval'],
        'date': value['date'],
        'cloud': value['cloud'],
        'maintenance': value['maintenance'],
        'amount': value['amount'],
    };
}

